import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RegistroEtiquetas from "components/etiquetas/RegistroEtiquetas";
import Navbar from "components/generales/Navbar";
import Boton from "components/boton/Boton";
import axios from "axios";
import "components/etiquetas/StylesEtiquetas.css";

const EditarEtiqueta = () => {
  const [etiqueta, setEtiqueta] = useState({});
  const [cargando, setCargando] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  // console.log(id);
  useEffect(() => {
    const obtenerEtiquetaApi = async () => {
      try {
        const { data } = await axios.get(
          `https://mymoney5.herokuapp.com/etiquetas/${id}`
        );
        setEtiqueta(data);
      } catch (error) {
        console.log(error);
      }
      setCargando(false);
    };
    obtenerEtiquetaApi();
  }, []);

  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenEtiquetas"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Editar Etiqueta</h2>
            {etiqueta?.descripcion ? (
              <RegistroEtiquetas etiqueta={etiqueta} cargando={cargando} />
            ) : (
              <p className="formulario-error">Etiqueta no encontrada</p>
            )}

            <Boton
              type="button"
              buttonStyle="botonPrimarioSolido"
              onClick={() => navigate(`/etiquetas/`)}
            >
              Regresar
            </Boton>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditarEtiqueta;
